import { Component, Input, ViewChild } from '@angular/core';
import { NbDialogRef, NbStepperComponent } from '@nebular/theme';

@Component({
    selector: 'app-cancel-subscription-token-validation',
    templateUrl: './cancel-subscription-token-validation.component.html',
    styleUrls: ['./cancel-subscription-token-validation.component.scss'],
})
export class CancelSubscriptionTokenValidationComponent {
    constructor(private dialogRef: NbDialogRef<CancelSubscriptionTokenValidationComponent>) {}
    typeSending: string;
    codeToken: string;
    @ViewChild(NbStepperComponent) stepper: NbStepperComponent;
    /**
     * Usuário para qual será solicitado o token
     */
    @Input('player') player: string;

    @Input('tournamentId') tournamentId: string;

    @Input('categoryId') categoryId: string;

    onTokenSent({ code, type_sending }) {
        this.typeSending = type_sending;
        this.codeToken = code;
        this.stepper.next();
    }

    onValidationSuccess(code) {
        this.dialogRef.close(code);
    }

    onClose() {
        this.dialogRef.close(false);
    }
}
